import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

import { PartnerDetailPage } from "./partner-detail-page";
import { PartnersPage } from "./partners-page";

const partnerDetailBreadcrumb = breadcrumbSlot();

export const partnersRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Partners" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { Component: Page };
    },
    children: [
      { index: true, element: <PartnersPage /> },
      {
        path: ":partnerId",
        handle: { breadcrumb: partnerDetailBreadcrumb },
        element: <PartnerDetailPage breadcrumb={partnerDetailBreadcrumb} />,
      },
    ],
  },
];
